import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import {
  BaseWebsocketMessage,
  SubWebsocketMessageRequest,
  WebsocketEntTypes,
  WebSocketService,
  WSEntityManager,
} from '@qtek/core/websockets-core';
import { DocumentTemplate, TemplateTypes } from '@qtek/shared/models';
import { Observable } from 'rxjs';
import { HttpEntityManager } from '../http-entity-manager';

@Injectable({
  providedIn: 'root',
})
export class DocumentTemplatesService extends HttpEntityManager<
  DocumentTemplate,
  DocumentTemplate
> {
  protected http = inject(HttpClient);
  private webSocketService = inject(WebSocketService);

  constructor() {
    super();
  }

  entityName: WebsocketEntTypes = 'tpl';
  wsManager = new WSEntityManager(this.webSocketService, this.entityName);

  readonly webSocketIsAlive$ = this.webSocketService.getWebSocketIsAlive$();

  subscribe(
    payload: Omit<SubWebsocketMessageRequest, 'ent' | 'op'>
  ): Observable<BaseWebsocketMessage> {
    return this.wsManager.subscribeEntity({ ...payload }, true);
  }

  subscribeTemplate(
    payload: Omit<SubWebsocketMessageRequest, 'ent' | 'op'>
  ): Observable<BaseWebsocketMessage> {
    return this.wsManager.subscribeEntity({ ...payload }, true);
  }

  createDocumentTemplate(
    documentTemplateName: string,
    documentTemplateType: TemplateTypes
  ): void {
    this.wsManager.create({
      res: { name: documentTemplateName, tp: documentTemplateType },
    });
  }

  updateDocumentTemplate(
    documentTemplateName: string,
    documentTemplateId: string
  ): void {
    this.wsManager.update({
      res: { name: documentTemplateName },
      id: documentTemplateId,
    });
  }

  deleteDocumentTemplate(documentTemplateId: string): void {
    this.wsManager.delete({ id: documentTemplateId });
  }
}
